module.exports = __webpack_public_path__ + "img/logo-camp-azul-horizontal.d5d9d528.png";